import React from "react";
import DotLegalDeleteDialogWrapper from "../../../common/components/dotLegalDeleteDialog/DotLegalDeleteDialogWrapper";
import { DeletionPeriodViewModel } from "../deletionPeriods/DeletionPeriods.types";
import { useDeleteDeletionPeriodDialogHooks } from "./DeleteDeletionPeriodDialog.hooks";

export interface IDeleteDeletionPeriod {
    onCloseDialog: () => void;
    onSaveCorrect: () => void;
    selectedDeletionPeriod: DeletionPeriodViewModel;
}

export function DeleteDeletionPeriodDialog(props: IDeleteDeletionPeriod) {
    const { removePurpose, inProgess } = useDeleteDeletionPeriodDialogHooks(props);

    return (
        <DotLegalDeleteDialogWrapper
            open
            itemForDeletion={props.selectedDeletionPeriod.name}
            onDialogClose={props.onCloseDialog}
            onOkClick={removePurpose}
            inProgress={inProgess}
        />
    );
}
